declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initMetaPixel = (pixelId: string) => {
  try {
    if (typeof window === 'undefined') return

    // Check if fbq already exists
    if (window.fbq) return

    // Initialize fbq
    const fbq: any = function () {
      fbq.callMethod
        ? fbq.callMethod.apply(fbq, arguments)
        : fbq.queue.push(arguments)
    }

    if (!window.fbq) window.fbq = fbq
    if (!window._fbq) window._fbq = fbq

    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []

    // Load the pixel script
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    script.onerror = () => {
      console.warn('Meta Pixel script blocked or failed to load')
    }

    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    }

    // Initialize pixel
    window.fbq('init', pixelId)
    window.fbq('track', 'PageView')
  } catch (error) {
    console.warn('Meta Pixel initialization error:', error)
  }
}

export const trackAddToCart = () => {
  try {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Sistema Mamá IA',
        content_type: 'product',
        value: 110,
        currency: 'MXN',
      })
    }
  } catch (error) {
    console.warn('Meta Pixel tracking error:', error)
  }
}
